import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import socket from '../utils/socket';
import jwtDecode from 'jwt-decode';
import throttle from 'just-throttle';
import { baseUrl } from '../utils/helper';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const showToast = throttle((message) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 1000,
  });
}, 8000);

// 🧼 Logout helper
function logoutUser(userId: string) {
  socket.emit('logout', { userId, token: localStorage.getItem('@App:token') }, (logoutAck: any) => {
    console.log('logoutAck', logoutAck);
  });

  socket.emit('disconnect_user', { userId }, (disconnectUserAck: any) => {
    console.log('disconnectUserAck', disconnectUserAck);
    socket.disconnect();
  });

  localStorage.removeItem('@App:user');
  localStorage.removeItem('@App:token');
  setAuthToken(false);

  window.location.href = '/login';
}

const Axios = axios.create({
  baseURL: baseUrl,
});

Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('@App:token');

  config.headers['x-auth-token'] = token;
  return config;
});

Axios.interceptors.response.use(null, (error) => {
  const token = localStorage.getItem('@App:token');
  const userDetails: any = token ? jwtDecode(token) : {};
  const { id: loginUserId = '' } = userDetails;

  const expectedError =
    error.response && error.response.status >= 400 && error.response.status < 500;

  if (!expectedError) {
    console.log('Logging the error', error);
    // alert(`An unexpected error occurred: ${error}`);
    showToast('An unexpected error occurred. Please try again.');
  }

  const message = error?.response?.data?.toLowerCase?.() || '';

  // 🔒 Handle invalid token
  if (error.response?.status === 400 && message.includes('invalid token')) {
    logoutUser(loginUserId);
  }

  // 🚫 Handle blocked user
  if (error.response?.status === 403 && message.includes('user is blocked')) {
    showToast('Your account has been blocked. Please contact support.');
    logoutUser(loginUserId);
  }

  return Promise.reject(error);
});

export default {
  get: Axios.get,
  post: Axios.post,
  put: Axios.put,
  delete: Axios.delete,
  patch: Axios.patch,
};
